import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface ICustomDynamicLocationCredentials {
    username: string;
    password: string;
    url: string;
}

class CustomDynamicLocationCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: ICustomDynamicLocationCredentials = {} as ICustomDynamicLocationCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }

    public set username(v: string) { this._changes.username = v; }

    public get password() { return this._changes.password; }

    public set password(v: string) { this._changes.password = v; }

    public get url() { return this._changes.url; }

    public set url(v: string) { this._changes.url = v; }
    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as ICustomDynamicLocationCredentials;
    }

    public getUpdatedModel(): ICustomDynamicLocationCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default CustomDynamicLocationCredentialsStore;
